import { HttpClient } from '../../httpClient'
import { OpalApi } from '../../schema'

type CreateCustomFieldV3 = OpalApi<'CreateCustomFieldV3', 201>

export const createCustomField: CreateCustomFieldV3 = async (args = {}) => {
  const url = new URL('/loupe/v3/custom_fields', window.location.origin)

  return HttpClient()
    .post(url.toString(), args.requestBody)
    .then((res) => res.data)
}
